import { render } from "./IFEProductNew.vue?vue&type=template&id=710fe7a5"
import script from "./IFEProductNew.vue?vue&type=script&lang=js"
export * from "./IFEProductNew.vue?vue&type=script&lang=js"
script.render = render

export default script